module.exports = __webpack_public_path__ + "static/media/promotional1.843908a2.jpeg";